import React from 'react';
import styled from 'styled-components';
import { QuickDrawer } from 'shared/components';
import { Button } from '../styles';

const HelpOverheadDrawer = ({ open, onClose }) => {
  return (
    <QuickDrawer
      width="620px"
      title="Example of the overhead cost of a program."
      open={open}
      onClose={onClose}
    >
      <DrawerContainer>
        <span>
          Use the example table below to calculate the direct cost of this
          program.
        </span>
        <div class="t">
          <div class="r title">
            <div class="c">Category</div>
            <div class="c">Value</div>
          </div>
          <div class="r first fill">
            <div class="c">Overhead Costs (Cash)</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Rent</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Utilities</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Insurance</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Office supplies</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Travel</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Advertising</div>
            <div class="c">$35,000</div>
          </div>
          <div class="r">
            <div class="c">Proffesional Services</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Goverment fees and licenses</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Property taxes</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Miscellaneous</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Volunteerism*</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Pro bono*</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Donated goods*</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r">
            <div class="c">Donated services*</div>
            <div class="c">$5,000</div>
          </div>
          <div class="r last">
            <div class="c">Overhead cost (In kind)</div>
            <div class="c">$110,000</div>
          </div>
        </div>
        <ButtonDrawer onClick={onClose}>Got it</ButtonDrawer>
      </DrawerContainer>
    </QuickDrawer>
  );
};

export default HelpOverheadDrawer;

const DrawerContainer = styled.div`
  width: 100%;
  padding: 30px;
  background-color: #f9f9f9;
  height: 100%;
  span {
    font-size: 17px;
    color: #505050;
  }
  .t {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    .r {
      flex: 1;
      display: flex;
      background-color: white;
      flex-direction: row;
      padding: 15px;
      border-top: solid 1px #ebebeb;
      border-left: solid 1px #ebebeb;
      border-rght: solid 1px #ebebeb;
      .c {
        flex: 1;
      }
    }
    .r.title {
      background-color: transparent !important;
      border-top: none !important;
      border-left: none !important;
      border-rght: none !important;
      .c {
        font-weight: 700;
      }
    }
    .r.first {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .r.last {
      background-color: #ebf0f6;
      border-bottom: solid 1px #ebebeb;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      .c {
        font-weight: 700;
      }
    }
    .r.fill {
      background-color: #ebf0f6 !important;
      .c {
        font-weight: 700;
      }
    }
  }
`;
const ButtonDrawer = styled(Button)`
  width: 100%;
  margin-bottom: 40px !important;
  span {
    color: #ffffff;
  }
`;
